export const redirectToCharlieErrorRoute = (
  charlieUser: { companyDomain: any },
  copy:
    | {
        action: string
        status: number
        shortCode: string
        title?: undefined
        description?: undefined
      }
    | {
        action: string
        title: string
        description: string
        status?: undefined
        shortCode?: undefined
      }
) =>
  window.location.replace(
    `https://${charlieUser.companyDomain}/insights/error?status=${copy.status}&short_code=${copy.shortCode}`
  )
